// checkDeleteButtonDisabled.tsx

import Personas from "../../models/componentModels/Personas";

interface Props {
  component: string;
  isLoggedInUser: boolean;
  userPersonaLoggedin: string;
  cellValues: {
    row: {
      roles: { name: string }[];
    };
  };
  OrganizationInformation?: {
    permissionSet?: {
      can_delete_organisation_user?: boolean;
    };
  };
  userPermissions?: {
    can_delete_organisation_user?: boolean;
    can_delete_user?: boolean;
  };
}

export const isDeleteButtonEnabled = (props: Props) => {
  const {
    component,
    isLoggedInUser,
    userPersonaLoggedin,
    cellValues,
    OrganizationInformation,
    userPermissions,
  } = props;

  // Initial check for props to ensure it's not null or undefined
  if (!props) return false;

  if (isLoggedInUser) {
    // To disable delete button for logged in user
    return false;
  }

  if (component === "organizationUserList") {
    return (
      OrganizationInformation?.permissionSet?.can_delete_organisation_user &&
      userPermissions?.can_delete_organisation_user
    );
  } else if (component === "tenantUserPage") {
    if (userPersonaLoggedin === Personas.HoneywellAdmin) {
      if (
        cellValues.row.roles.some(
          (x: { name: string }) => x.name === Personas.TenantAdmin
        )
      ) {
        return true;
      }
    } else if (userPersonaLoggedin === Personas.TenantAdmin) {
      return true;
    } else {
      return userPermissions?.can_delete_user;
    }
  }
  // If its not returned from above conditions, return false
  return false;
};
